import { Dayjs } from "dayjs";
import { useState } from "react";

export const useDateTime = (initialValue?: Dayjs) => {

  const [ datetime, setDateTime ] = useState<Dayjs | undefined>(initialValue ? initialValue.clone() : undefined);

  return [ datetime, setDateTime ] as const;
};
